import { render, staticRenderFns } from "./generate-wages.vue?vue&type=template&id=406c4d76"
import script from "./generate-wages.vue?vue&type=script&lang=js"
export * from "./generate-wages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports